import { Button, TextArea } from "@newsela/angelou";
import { actionNames, actionPrefixes, withTrackEvent } from "@newsela/snitch";
import PropTypes from "prop-types";

import reportSources from "@/view/constants/reportSources";
import TT_AND_AUTO_WP_COPY from "@/view/constants/teacherToolsAndAutoGenWritePrompts";
import {
  textAreaCss,
  actionButtonGroupCss,
  buttonCss,
} from "./ReportContentForm.style";

const ButtonWithTrackEvent = withTrackEvent(Button);

const propTypes = {
  ariaProps: PropTypes.object,
  handleCancelReport: PropTypes.func,
  handleSubmitReport: PropTypes.func,
  handleTextAreaChange: PropTypes.func,
  heading: PropTypes.node,
  id: PropTypes.string,
  rootStyles: PropTypes.object,
  textAreaValue: PropTypes.string,
  reportSource: PropTypes.oneOf(Object.values(reportSources)),
};

const defaultProps = {
  rootStyles: {},
};

const ReportContentForm = ({
  ariaProps,
  handleCancelReport,
  handleSubmitReport,
  handleTextAreaChange,
  heading,
  id,
  rootStyles,
  textAreaValue,
  reportSource,
}) => {
  const sources = {
    WritePrompt: {
      selector: "gen_write_prompts",
      description: "generated write prompts",
    },
    ArticleTopics: {
      selector: "article_topics",
      description: "article topics",
    },
    KeyTerm: {
      selector: "key_term",
      description: "generated key term",
    },
    ChecksForUnderstanding: {
      selector: "checks_for_understanding",
      description: "checks for understanding",
    },
  };

  const dataSource = sources[reportSource] || sources.WritePrompt;

  return (
    <form id={id} css={rootStyles}>
      {heading}
      <TextArea
        __cssFor={textAreaCss}
        defaultHeight={96}
        label={TT_AND_AUTO_WP_COPY.REPORT_FEEDBACK}
        onChange={handleTextAreaChange}
        placeholder="Start typing..."
        value={textAreaValue}
      />
      <div style={actionButtonGroupCss}>
        <ButtonWithTrackEvent
          actionName={actionNames.update}
          actionPrefix={actionPrefixes.cancel}
          __cssFor={{ root: buttonCss }}
          ariaProps={ariaProps || undefined}
          flavor={Button.flavors.secondary}
          onClick={handleCancelReport}
          dataProps={{
            "data-qa-selector": `cancel_problem_report_with_${dataSource.selector}`,
          }}
          streamProperties={{
            description: `Cancel problem report with ${dataSource.description}`,
          }}
        >
          Cancel
        </ButtonWithTrackEvent>
        <ButtonWithTrackEvent
          actionName={actionNames.flag}
          actionPrefix={actionPrefixes.initiate}
          __cssFor={{ root: buttonCss }}
          ariaProps={ariaProps || undefined}
          onClick={handleSubmitReport}
          dataProps={{
            "data-qa-selector": `submit_problem_report_with_${dataSource.selector}`,
          }}
          streamProperties={{
            description: `Submit problem report with ${dataSource.description}`,
          }}
        >
          Submit Report
        </ButtonWithTrackEvent>
      </div>
    </form>
  );
};

ReportContentForm.defaultProps = defaultProps;
ReportContentForm.propTypes = propTypes;

export default ReportContentForm;
